import { createSelector } from 'reselect';
import { AulaState, IntegrationsState } from '@core/types/state';

export const getIntegrationsState = (
  state: AulaState
): IntegrationsState | undefined => state.integrations;

export const getOutlookConnection = createSelector(
  [getIntegrationsState],
  (integrations) => {
    const connection = integrations?.connection;
    const status = connection?.status ?? 'none';
    return {
      status,
      accountEmail: connection?.accountEmail ?? null,
      isConnected: status === 'active',
      needsReauth: status === 'needs_reauth',
      isLoadingStatus: connection?.isLoading ?? false,
      errorCode: connection?.errorCode ?? null,
    };
  }
);

export const getOutlookEmails = createSelector(
  [getIntegrationsState],
  (integrations) => {
    const emails = integrations?.emails;
    return {
      rawItems: emails?.items ?? [],
      nextLink: emails?.nextLink ?? null,
      hasMoreEmails: Boolean(emails?.nextLink),
      isLoadingEmails: emails?.isLoading ?? false,
      isLoadingMoreEmails: emails?.isLoadingMore ?? false,
      emailsError: emails?.error ? ('load-error' as const) : null,
      unreadCount: emails?.unreadCount ?? 0,
    };
  }
);

export const getOutlookEmailDetail = createSelector(
  [getIntegrationsState],
  (integrations) => {
    const detailState = integrations?.emailDetail;
    return {
      rawDetail: detailState?.detail ?? null,
      isLoadingDetail: detailState?.isLoading ?? false,
      detailError: detailState?.error ?? null,
    };
  }
);
